import * as Result from './Result'
import {parse} from './JsonHelper'
import {LocalDate, LocalDateTime} from 'js-joda'
import {
    andThen,
    array,
    Decoder,
    errorToString,
    fail,
    forNull,
    oneOf,
    string,
    succeed
} from 'json-bouncer'
import {Set} from 'immutable'

export function decodeJson<T>(
    decoder: Decoder<T>,
    json: string
): Result.Result<string, T> {
    return Result.andThen(
        object => Result.mapError(errorToString, decoder(object)),
        parse(json),
    )
}

export function localDateTimeDecoder(): Decoder<LocalDateTime> {
    return andThen(
        value => {
            try {
                return succeed(LocalDateTime.parse(value))
            } catch (e) {
                return fail(e.message)
            }
        },
        string(),
    )
}

export function localDateDecoder(): Decoder<LocalDate> {
    return andThen(
        value => {
            try {
                return succeed(LocalDate.parse(value))
            } catch (e) {
                return fail(e.message)
            }
        },
        string(),
    )
}

export function nonemptyArrayDecoder<T>(decoder: Decoder<T>): Decoder<T[]> {
    return andThen(
        (value: T[]): Decoder<T[]> =>
            value.length > 0 ? succeed(value) : fail('Nonempty array'),
        array(decoder),
    )
}

export function nullableWithDefaultDecoder<T>(
    defaultValue: T,
    decoder: Decoder<T>
): Decoder<T> {
    return oneOf([decoder, forNull(defaultValue)])
}

export function set<T>(decoder: Decoder<T>): Decoder<Set<T>> {
    return andThen(
        (value: T[]): Decoder<Set<T>> =>
            succeed(Set(value)),
        array(decoder),
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/DecodeHelper.ts